import { Component, OnInit, Input } from "@angular/core";
import { BookServiceService } from "src/app/services/book-service.service";

@Component({
  selector: "app-recently-added",
  templateUrl: "./recently-added.component.html",
  styleUrls: ["./recently-added.component.scss"]
})
export class RecentlyAddedComponent implements OnInit {
  constructor(private books: BookServiceService) {}
  customOptions: any = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    navText: ["", ""],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      }
    },
    nav: true
  };

  @Input() cards: [];

  slides: any = [[]];
  chunk(arr, chunkSize) {
    let R = [];
    for (let i = 0, len = arr.length; i < len; i += chunkSize) {
      R.push(arr.slice(i, i + chunkSize));
    }
    return R.reverse();
  }

  navigate() {
    console.log("clicked by diyasty ");
  }
  @Input() title: string;

  isload: boolean = false;

  ngOnInit() {}
}
